import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import logoBlack from "../../assets/SorinBlack.png";
import { FaInstagram, FaTiktok } from "react-icons/fa";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          const headerOffset = 80;
          const y = el.getBoundingClientRect().top + window.scrollY - headerOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 400);
      return;
    }
    if (section) {
      const headerOffset = 80;
      const y = section.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      <style>
        {`
          .footer-button:hover, .footer-link:hover {
            color: #dc814c !important;
          }
          .footer-send-btn:hover {
            background-color: #dc814c !important;
          }
          .footer-logo:hover {
            transform: scale(1.02);
          }
          
          @media (max-width: 900px) {
            .footer-wrapper {
              flex-direction: column !important;
              gap: 30px !important;
            }
            .footer-nav {
              flex-direction: column !important;
              gap: 16px !important;
              margin-left: 0 !important;
            }
            .footer-subscribe {
              width: 85% !important;
              max-width: 100% !important;
            }
          }

          @media (max-width: 480px) {
            .footer-subscribe {
              width: 90% !important;
            }
          }
        `}
      </style>

      <footer style={{ width: "100%", backgroundColor: "#f7f7f5", color: "#000", padding: "70px 80px 40px", fontFamily: "Inter, sans-serif", borderTop: "1px solid rgba(0,0,0,0.2)", boxSizing: "border-box" }}>
        
        <div className="footer-wrapper" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", maxWidth: "1200px", margin: "0 auto", gap: "40px", textAlign: "center", flexWrap: "wrap" }}>
          
          {/* Logo */}
          <div style={{ flex: "0 0 auto", display: "flex", justifyContent: "center" }}>
            <img className="footer-logo" src={logoBlack} alt="SORIN Logo" onClick={() => scrollToSection("hero")} style={{ height: "30px", cursor: "pointer", transition: "transform 0.3s ease" }} />
          </div>

          {/* Nav - Horizontal */}
          <div className="footer-nav" style={{ flex: "1", display: "flex", justifyContent: "center", alignItems: "center", gap: "32px", flexWrap: "wrap", marginLeft: "60px" }}>
            <button className="footer-button" onClick={() => scrollToSection("hero")} style={{ background: "none", border: "none", fontFamily: "DM Serif Display, serif", fontSize: "1rem", cursor: "pointer", color: "#000", transition: "color 0.3s ease" }}>HOME</button>
            <button className="footer-button" onClick={() => scrollToSection("products")} style={{ background: "none", border: "none", fontFamily: "DM Serif Display, serif", fontSize: "1rem", cursor: "pointer", color: "#000", transition: "color 0.3s ease" }}>SCENTS</button>
            <button className="footer-button" onClick={() => scrollToSection("brand")} style={{ background: "none", border: "none", fontFamily: "DM Serif Display, serif", fontSize: "1rem", cursor: "pointer", color: "#000", transition: "color 0.3s ease" }}>ABOUT US</button>
            <a className="footer-link" href="https://www.instagram.com/perfumebysorin/" target="_blank" rel="noreferrer" style={{ fontSize: "1.2rem", color: "#000", transition: "color 0.3s ease" }}><FaInstagram /></a>
            <a className="footer-link" href="https://www.tiktok.com/@perfumebysorin" target="_blank" rel="noreferrer" style={{ fontSize: "1.2rem", color: "#000", transition: "color 0.3s ease" }}><FaTiktok /></a>
          </div>

          {/* Subscribe */}
          <div className="footer-subscribe" style={{ flex: "0 0 auto", display: "flex", flexDirection: "column", alignItems: "center", width: "340px", maxWidth: "340px" }}>
            <p style={{ fontFamily: "DM Serif Display, serif", fontSize: "1rem", marginBottom: "8px", textAlign: "center" }}>Join Us for Exclusive Offers!</p>
            <div style={{ display: "flex", alignItems: "stretch", width: "100%", backgroundColor: "#fff", height: "46px", borderRadius: "8px", overflow: "visible", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
              <input 
                type="email" 
                placeholder="Email address" 
                style={{ 
                  width: "65%",
                  border: "none", 
                  outline: "none", 
                  padding: "0 14px", 
                  fontSize: "0.9rem",
                  borderRadius: "8px 0 0 8px",
                  backgroundColor: "#fff"
                }} 
              />
              <button 
                className="footer-send-btn" 
                style={{ 
                  width: "35%",
                  backgroundColor: "#000", 
                  color: "#fff", 
                  fontSize: "0.9rem", 
                  fontWeight: "600", 
                  border: "none", 
                  cursor: "pointer", 
                  transition: "background-color 0.3s ease",
                  borderRadius: "0 8px 8px 0"
                }}
              >
                Send
              </button>
            </div>
          </div>
        </div>

        <div style={{ width: "90%", height: "1px", backgroundColor: "rgba(0,0,0,0.2)", margin: "50px auto 20px" }} />
        <p style={{ fontSize: "0.85rem", textAlign: "center", margin: "0" }}>© 2025 SORIN. All rights reserved.</p>
      </footer>
    </>
  );
};

export default Footer;